module.exports = __webpack_public_path__ + "img/icon-done.4e26b281.svg";